import { dataMember, required, typedArray } from 'santee-dcts';

export class CommonLink {
    @dataMember()
    @required()
    public linkTitle: string;

    @dataMember()
    @required()
    public linkUrl: string;

    @dataMember()
    @required({ nullable: true })
    public linkDescription: string;
}

export class CommonLinksRealModel {
    @dataMember()
    @required()
    @typedArray(CommonLink)
    public commonLinks: CommonLink[];
}